(function(){
  function miniMarkup(){
    return '<aside class="culm-forest-mini" aria-label="CULM Forest commitment">'+
      '<span class="culm-forest-mini__icon" aria-hidden="true">⌇</span>'+
      '<div><span class="culm-forest-mini__kicker">CULM Forest / one order · one tree</span>'+
      '<strong>Your completed order commits funding for one tree planting.</strong>'+
      '<p>Dedicated in the name on the order. Planting evidence is recorded when verified; this is not presented as a carbon offset.</p></div></aside>';
  }

  function initProduct(){
    var form=document.querySelector('.culm-shirt-product__form');
    if(!form || document.querySelector('.culm-shirt-product .culm-forest-mini')) return;
    form.insertAdjacentHTML('afterend',miniMarkup());
  }

  function initCart(){
    var cart=document.querySelector('.culm-cart');
    if(!cart) return;
    var form=cart.querySelector('form');
    if(form && !form.querySelector('input[data-culm-forest-attribute]')){
      var input=document.createElement('input');
      input.type='hidden';
      input.name='attributes[CULM Forest Commitment]';
      input.value='One completed order / one tree planting commitment';
      input.setAttribute('data-culm-forest-attribute','');
      form.appendChild(input);
    }
    var summary=cart.querySelector('.culm-cart__summary');
    if(summary && !cart.querySelector('.culm-forest-cart')){
      summary.insertAdjacentHTML('beforebegin','<aside class="culm-forest-cart" aria-label="CULM Forest order commitment"><div class="culm-forest-cart__head"><span>This order / CULM Forest</span><strong>One order. One tree.</strong></div><p>When this order is completed, CULM commits funding for one tree planting and dedicates the record in the name on the order. Partner and planting evidence are published when verified.</p><div class="culm-forest-cart__flow" aria-hidden="true"><span>Order</span><span>→</span><span>Tree funded</span><span>→</span><span>Name dedicated</span><span>→</span><span>Evidence recorded</span></div></aside>');
    }
  }

  function init(){initProduct();initCart();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
